import {
  PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  FACETED_SEARCH_QUERY,
  PRODUCTS_SET_IS_LOADING,
} from '../constants';

const defaultState = {
  name: null,
  url: null,
  productsWrapper: {
    categorySystemId: null,
    products: [],
    pagination: {},
  },
  filterQuery: null,
  isLoading: false,
};

export const productsView = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FACETED_SEARCH_QUERY: {
      state.filterQuery = payload.query;
      return state;
    }

    case PRODUCTS_RECEIVE_PRODUCTS_WRAPPER:
    case PRODUCTS_SET_IS_LOADING:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
